import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css/bundle';

const embedReady = 'podcast-carousel__embed--ready';

function loadVisibleEmbeds(swiper) {
	const slides = swiper.slides;
	let perView = swiper.params.slidesPerView;
	if (perView === 'auto') perView = 1;
	const buffer = 1;

	slides.forEach((slide, index) => {
		const iframe = slide.querySelector('iframe[data-src]');
		if (!iframe) return;

		const min = Math.max(0, swiper.activeIndex - buffer);
		const max = swiper.activeIndex + perView + buffer;
		const isNearby = index >= min && index < max;

		if (isNearby && !iframe.src) {
			iframe.addEventListener(
				'load',
				() => {
					iframe.classList.add(embedReady);
				},
				{ once: true }
			);
			iframe.src = iframe.dataset.src;
		}
	});
}

export default () => {
	const rows = [...document.querySelectorAll('.podcast-carousel__row')];

	rows.forEach((row) => {
		const carouselEl = row.querySelector('.podcast-carousel');
		const carouselPrev = row.querySelector('.podcast-carousel__prev')	
		const carouselNext = row.querySelector('.podcast-carousel__next')

		if (!carouselEl) return;

		new Swiper(carouselEl, {
			modules: [Navigation],
			speed: 500,
			slidesPerView: 1.2,
			slidesPerGroup: 1,
			loop: false,
			spaceBetween: 32,
			navigation: {
				nextEl: carouselNext,
				prevEl: carouselPrev,
			},
			on: {
				init() {
					loadVisibleEmbeds(this);
				},
				slideChange() {
					loadVisibleEmbeds(this);
				},
				breakpoint() {
					loadVisibleEmbeds(this);
				},
			},
			breakpoints: {
				780: {
					slidesPerView: 1.72,
					slidesPerGroup: 1,
				},
				1124: {
					slidesPerView: 2.5,
					slidesPerGroup: 1,
				},
				1650: {
					slidesPerView: 3.2,
					slidesPerGroup: 1,
				},
			},
		});
	});
};
